import React from 'react'
import { Control, useController } from 'react-hook-form'

import { TaxFormValues } from '@frame/components/screens/tasks/screens/strategies/tax/types'

import { Address } from './index'

type Props = {
  control: Control<TaxFormValues>
  clearErrors: (key: string) => void
  disabled?: boolean
}

export function ApplicantTaxAddress({ clearErrors, disabled = false, control }: Props) {
  const { field, fieldState } = useController({
    name: 'address',
    control,
    rules: {
      validate: (value) => {
        if (!value?.place_id) {
          return 'Required'
        }
        return true
      },
    },
  })

  return (
    <Address
      name={field.name}
      value={field.value}
      label="Address you filed your taxes under"
      noAddress={false}
      onChange={field.onChange}
      errors={fieldState.error?.message}
      clearErrors={clearErrors}
      disabled={disabled}
    />
  )
}
